import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';

import Navbar from '../sections/wealth/Navbar';
import Info from '../sections/wealth/Info';
import Stake from '../sections/wealth/Stake';
import Disclaimer from '../sections/wealth/Disclaimer';

const useStyles = makeStyles((theme) => {
    return {
      root: {
          flexGrow: 1
      }
    }
  });
  
  function Wealth() {
      const classes = useStyles();
      return (
          <div className={ classes.root }>
            <Navbar/>
            <Info/>
            <Stake/>
            <Disclaimer/>
          </div>    
      );
    }
    
  export default Wealth;